import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import useFetchList from "../../utils/useFetchLIst";
import DispatchedForm from "./DispatchedForm";
import { loaderOverlay } from "../../Style/loaderOverly";
import { LoaderCreatePage } from "../Loader/Loader";
import { saveRecords } from "../../services/api.service";
// import useFetchList from "../../../utils/useFetchList";

const DispatchedCreate = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    job_card_no: "",
  });
  const [selectedJobCard, setSelectedJobCard] = useState(null); // Add this line
  const [errors, setErrors] = useState({});
  const [jobCArdsOptions, setJobCardsOptions] = useState([]);
  const [showDispatchForm, setShowDispatchForm] = useState(false);
  const navigate = useNavigate();
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "job_cards",
    schema: schema,
    whereCondition: {
      is_active: true,
      status: "Repair Completed",
    },
    orderBy: {
      field: "job_card_no",
      order: "asc",
    },
    include: [
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      },
    ],
  };

  const { data: jobCardData, loading } = useFetchList("/getRecords", payload);

  const selectedJobCardData = jobCardData.find(
    (item) => item.id === selectedJobCard?.value
  );

  useEffect(() => {
    if (jobCardData) {
      const options = jobCardData.map((job) => ({
        value: job.id,
        label: job.job_card_no,
      }));

      setJobCardsOptions(options);
    }
  }, [jobCardData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name === "job_card_no" && value) {
      jobCArdsOptions.map((job_card_no) => {
        if (job_card_no.value === value) {
          setSelectedJobCard({ value, label: job_card_no.label });
        }
      });
      setShowDispatchForm(false);
    } else setShowDispatchForm(false);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};
    let valid = true;

    if (!String(formData.job_card_no).trim()) {
      newErrors.job_card_no = "Job Card cannnot be blank.";
      valid = false;
    }

    if (!valid) {
      setErrors(newErrors);
      return;
    }

    setShowDispatchForm(true);
  };

  return (
    <>
      <div className="page-content">
        <Breadcrumbs title={"Dispatch Job Card"} breadcrumbItems={[]} />
        <div className="card mb-3">
          <div className="container-fluid p-4 ">
            <p className="text-muted pb-1">
              Fields marked with <span className="text-danger fw-bold">*</span>{" "}
              are required.
            </p>
            <form onSubmit={handleFormSubmit}>
              <div className="row mb-3 align-items-center">
                <div className="col-12 col-md-6">
                  <div className="mb-3">
                    <label className="form-label custom-label">
                      Job Card <span className="text-danger">*</span>
                    </label>
                    <Select
                      className={`font-size-13 ${
                        errors.job_card_no ? "is-invalid" : ""
                      }`}
                      options={jobCArdsOptions}
                      value={selectedJobCard}
                      onChange={(selectedOption) => {
                        handleChange({
                          target: {
                            name: "job_card_no",
                            value: selectedOption ? selectedOption.value : "",
                          },
                        });
                        setSelectedJobCard(
                          selectedOption ? selectedOption : ""
                        );
                      }}
                      placeholder="Select Job Card"
                      isSearchable
                      isClearable
                      onMenuOpen={() => {}}
                      menuPortalTarget={document.body}
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          borderColor: errors.job_card_no
                            ? "#dee2e6"
                            : base.borderColor,
                          boxShadow: errors.job_card_no
                            ? "0 0 0 0.5px red"
                            : base.boxShadow,
                          "&:hover": {
                            borderColor: errors.job_card_no
                              ? "#dee2e6"
                              : base.borderColor,
                          },
                        }),
                      }}
                    />
                    {errors.job_card_no && (
                      <div className="invalid-feedback">
                        {errors.job_card_no}
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-6 mt-3 mb-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{
                      width: "80px",
                      fontSize: "13px",
                    }}
                  >
                    GO{" "}
                  </button>
                </div>
              </div>
            </form>
          </div>
          {loading && (
            <div style={loaderOverlay}>
              <LoaderCreatePage />
            </div>
          )}
        </div>
        {showDispatchForm && (
          <DispatchedForm
            jobCardData={selectedJobCardData}
            jobCardNo={selectedJobCard?.label}
          />
        )}
      </div>
    </>
  );
};

export default DispatchedCreate;
